import * as React from 'react';
import { useInstantSearch, Configure } from 'react-instantsearch';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { Container, Heading } from '@grandvisionhq/elements';
import { FacetsMobile } from '../Algolia/components/FacetsMobile/FacetsMobile.js';
import FacetsDesktop from '../Algolia/components/FacetsDesktop/FacetsDesktop.js';
import VirtualFacets from '../Algolia/components/VirtualFacets/VirtualFacets.js';
import { SortBy } from '../Algolia/components/SortBy/SortBy.js';
import '@swc/helpers';
import 'algoliasearch/lite';
import 'react-dom/server';
import { useAlgoliaConfig } from '../Algolia/AlgoliaConfig.js';
import 'lodash/merge';
import { FacetId } from '../types.js';
import '@grandvisionhq/utils';
import '../Algolia/utils/query-string.js';
import '../Algolia/AlgoliaDataProvider.js';
import '../Algolia/AlgoliaAnalytics.js';
import '@grandvisionhq/products';
import '@grandvisionhq/state';
import '../CrossSellProducts/utils/create-algolia-filters.js';
import hasProductTypeFacet from '../Algolia/utils/has-Product-type-facet.js';
import { SearchPageDescription } from './components/SearchPageDescription/SearchPageDescription.js';
import { parseFacets } from './utils/parse-facets.js';

const ProductPageSelectorGroup = ({ productPageSelector =[]  })=>/*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__product-page-selectors"
    }, productPageSelector.map((element, index)=>{
        return /*#__PURE__*/ React.createElement(Button, {
            key: `${element.name}-${index}}`,
            className: "search-page-header__product-page-selectors-button",
            "data-t": element.name,
            href: element.url,
            hrefTarget: "_self",
            caption: element.label,
            variant: 'solid',
            color: 'primary',
            size: "small"
        });
    }))
;
const SearchPageHeader = ({ pageTitle , hitTitle , description , facetOrder , productPageSelector ,  })=>{
    var ref, ref1;
    const { facets , algoliaInstantSearchProps: { searchClient , indexName , onStateChange , searchState  } , sortIndices , facetingAfterDistinct ,  } = useAlgoliaConfig();
    const { indexUiState  } = useInstantSearch();
    const isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
    const hasProductType = hasProductTypeFacet(indexUiState, facets);
    const productTypeFacet = facets.find((facet)=>facet.id === FacetId.productType
    );
    const productTypeFacetValue = productTypeFacet && indexUiState.refinementList ? (ref = indexUiState.refinementList[productTypeFacet.attribute]) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase() : undefined;
    const facetsVisible = parseFacets({
        facets,
        hasProductType,
        facetOrder,
        productTypeFacetValue
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(VirtualFacets, null), /*#__PURE__*/ React.createElement(Configure, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct
    }), /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header"
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "search-page-header__container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__intro"
    }, pageTitle && /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        component: "h1",
        className: "search-page-header__title"
    }, pageTitle), description && /*#__PURE__*/ React.createElement(SearchPageDescription, {
        description: description
    })), isMobile && (productPageSelector === null || productPageSelector === void 0 ? void 0 : productPageSelector.length) ? /*#__PURE__*/ React.createElement(ProductPageSelectorGroup, {
        productPageSelector: productPageSelector
    }) : null, isMobile && /*#__PURE__*/ React.createElement(FacetsMobile, {
        facets: facetsVisible
    }), (hitTitle || sortIndices) && /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-results"
    }, hitTitle && /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__amount-hits",
        "data-t": "plp-amount-hits"
    }, hitTitle), sortIndices.length > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-by"
    }, /*#__PURE__*/ React.createElement(SortBy, {
        items: sortIndices
    })) : null), !isMobile && (productPageSelector === null || productPageSelector === void 0 ? void 0 : productPageSelector.length) ? /*#__PURE__*/ React.createElement(ProductPageSelectorGroup, {
        productPageSelector: productPageSelector
    }) : null), !isMobile && /*#__PURE__*/ React.createElement(FacetsDesktop, {
        facets: facetsVisible
    })));
};

export { SearchPageHeader, SearchPageHeader as default };
//# sourceMappingURL=SearchPageHeader.js.map
